import React from 'react';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpClientPaymentRefundItem from '../../../Domain/TpClientPaymentRefundItem';
import TpClientPaymentRefundService from '../../../Services/TpClientPaymentRefundService';

export default class TpClientPaymentDetailsRefundTab extends React.Component {
  static defaultProps = {
    tpClientPaymentId: 0,
  };

  constructor(props) {
    super(props);
    
    this.state = {
      searchItem: { TpClientPaymentId: props.tpClientPaymentId },
    };
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          type={TpClientPaymentRefundItem}
          serviceFunction={TpClientPaymentRefundService.GetListBySearching}
          convertDBItemsFunction={TpClientPaymentRefundService.ConvertDBItems}
          searchItem={this.state.searchItem}
          orderBy='Reason'
          errorCode='CPDRT23'
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
